import { Dropdown, Menu } from 'antd';
import React, { useRef } from 'react';
import styles from './contextmenu.module.scss';
import { copyText, selectElement } from './util';
import { getIn18Text } from 'api';
const TitleRightContextMenu = ({ children, targetNode }) => {
    const rangeText = useRef();
    return (React.createElement(Dropdown, { onVisibleChange: v => {
            var _a, _b;
            if (v) {
                if ((_a = document.getSelection()) === null || _a === void 0 ? void 0 : _a.toString()) {
                    rangeText.current = (_b = document.getSelection()) === null || _b === void 0 ? void 0 : _b.toString();
                }
            }
        }, overlay: React.createElement(Menu, { className: styles.dropdownMenu },
            React.createElement(Menu.Item, { key: "1", onClick: () => {
                    if (rangeText.current) {
                        copyText(rangeText.current);
                    }
                } }, getIn18Text('FUZHI')),
            React.createElement(Menu.Item, { key: "2", onClick: () => {
                    if (targetNode) {
                        selectElement(targetNode);
                    }
                } }, getIn18Text('QUANXUAN'))), trigger: ['contextMenu'] }, children));
};
TitleRightContextMenu.defaultProps = {
    targetNode: null,
    children: undefined,
};
export default TitleRightContextMenu;
